var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill",class:{'badge-success': _vm.count > 0, 'badge-secondary': _vm.count === 0, }},[_vm._v("\n    "+_vm._s(_vm.count)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }